module.exports = __webpack_public_path__ + "img/Human_holding_bread.0197b575.jpeg";